import Vue from "vue"
import uniqid from "uniqid"
import * as utils from "@/Shared/utils"
import store from "@/store/index.js"
import { SECONDARY_OWNER_ANY } from "@/Shared/constants"

export default new Vue({
  name: "XVATRulesService",
  data: {},
  methods: {

    /**
     * addClientOnlyFields - adds below list of fiels
     *  '_enabled'
     *  '_updated'
     *  '_added'
     * @param {*} inputItem
     * @returns {*}
     */
    addClientOnlyFields(inputItem) {
      if (this.$lodash.isArray(inputItem)) {
        let itemObj
        for (let index in inputItem) {
          itemObj = inputItem[index]
          itemObj["_enabled"] = !this.$lodash.isNull(itemObj.disabled)
            ? !itemObj.disabled
            : ""
          itemObj["_updated"] = !this.$lodash.isNull(itemObj.updated)
            ? utils.getLocalDateTime(itemObj.updated)
            : "---"
          itemObj["_added"] = !this.$lodash.isNull(itemObj.added)
            ? utils.getLocalDateTime(itemObj.added)
            : "---"
        }
      } else if (this.$lodash.isObject(inputItem)) {
        inputItem["_enabled"] = !this.$lodash.isNull(inputItem.disabled)
          ? !inputItem.disabled
          : ""
        inputItem["_updated"] = !this.$lodash.isNull(inputItem.updated)
          ? utils.getLocalDateTime(inputItem.updated)
          : ""
        inputItem["_added"] = !this.$lodash.isNull(inputItem.added)
          ? utils.getLocalDateTime(inputItem.added)
          : ""
      }

      return inputItem
    },

    /**
     * omitClientOnlyFields - removes client only fields
     *  '_enabled'
     *  '_updated'
     *  '_added'
     * @param {*} inputItem
     * @returns {*}
     */
    omitClientOnlyFields(inputItem) {
      if (this.$lodash.isArray(inputItem)) {
        let itemObj
        for (let index in inputItem) {
          itemObj = inputItem[index]
          itemObj = this.$lodash.omit(itemObj, ["_added", "_enabled", "_updated"])
        }
      } else if (this.$lodash.isObject(inputItem)) {
        inputItem = this.$lodash.omit(inputItem, ["_added", "_enabled", "_updated"])
      }

      return inputItem
    },

    /**
     * addIds - adds unique ids to objects in array
     * @param {*} itemsList
     * @returns {array}
     */
    addIds(itemsList) {
      if (!this.$lodash.isArray(itemsList)) {
        return itemsList
      }
      this.$lodash.forEach(itemsList, item => {
        item["id"] = uniqid()
        if (!this.$lodash.isUndefined(item.conditionResults)) {
          this.$lodash.forEach(item.conditionResults, conditionResult => {
            conditionResult["id"] = uniqid()
          })
        }
        if (!this.$lodash.isUndefined(item.actionResults)) {
          this.$lodash.forEach(item.actionResults, actionResult => {
            actionResult["id"] = uniqid()
          })
        }
      })

      return itemsList
    },

    /**
     * stringifyArrayOfObjects - Used to convert the array of objects to array of strings
     * @param {array} arrayOfObjects
     * @returns {array }
     */
    stringifyArrayOfObjects(arrayOfObjects) {
      let arrayOfStrings = []
      if (arrayOfObjects.length > 0) {
        this.$lodash.forEach(arrayOfObjects, (object, index) => {
          // Remove Id & sequence before stringifying ( i.e. before sending it to backend)
          if (!this.$lodash.isUndefined(object.id)) {
            object = this.$lodash.omit(object, ["id", "sequence", "_fieldName"])
          }
          arrayOfStrings[index] = JSON.stringify(object)
        })
      }

      return arrayOfStrings
    },

    /**
     * stringifyArrayObjects - Used to convert the array of objects to array of strings
     * @param {array} arrayOfObjects
     * @param {boolean} addId
     * @returns {array }
     */
    parseArrayOfStrings(arrayOfStrings, addId) {
      let arrayOfObjects = []

      if (arrayOfStrings.length > 0) {
        this.$lodash.forEach(arrayOfStrings, (stringObject, index) => {
          try {
            let parsedObject = JSON.parse(stringObject)
            if (addId) {
              parsedObject["id"] = uniqid() // Add 'id' attribute to make it easy to manage on the client
            }
            arrayOfObjects[index] = parsedObject
          } catch (err) {
            // TODO: Might not require this in future but needed now as
            // we have some manual data entered as just strings
            arrayOfObjects[index] = stringObject
          }
        })
      }

      return arrayOfObjects
    },

    /**
     * stringifyArrayObjects - Used to convert the array of objects to array of strings
     * @param {array} inputArrayOfObjects
     * @returns {array }
     */
    addUniqIds(inputArrayOfObjects) {
      if (inputArrayOfObjects.length > 0) {
        this.$lodash.forEach(inputArrayOfObjects, (object) => {
          object["id"] = uniqid() // Add 'id' attribute to make it easy to manage on the client
        })
      }

      return inputArrayOfObjects
    },

    /**
     * getRuleTypeList - Get list of rule / ruleset / rule collection
     * @returns {Array}
     */
    getRuleTypeList(/* context */) {
      let ruleTypes = [
        {
          title: "Validation",
          value: "VALIDATION"
        },
        {
          title: "Transformation",
          value: "TRANSFORMATION"
        }
      ]

      return ruleTypes
    },

    /**
     * getOwnerLabel
     * @param {string} value
     */
    getOwnerLabel(value) {
      if (value && value.toLowerCase() === "ownerid") {
        return "Owner"
      } else if (value && value.toLowerCase() === "secondaryowner") {
        return "Provider"
      } else if (value && value.toLowerCase() === "providergroup") {
        return "Provider Group"
      } else {
        return value
      }
    },

    /**
     * getOwnerName - Display owner name, owner could be the selected parent account
     * or a provider group name in case of Polaris
     * @param {string} ownerId
     * @param {string} parentAccountId
     * @param {array} subAccounts
     * @returns {string}
     */
    getOwnerName(ownerId, parentAccountId, subAccounts, isPolaris) {
      if (parentAccountId === ownerId) {
        return store.state.mpxParentAccount.title
      } else {
        if (isPolaris) {
          let ownerProviderGroup = this.$lodash.find(subAccounts, {
            ownerId: ownerId
          })
          if (ownerProviderGroup) {
            return ownerProviderGroup.title
          } else {
            // FIXME: THIS SHOULD NOT BE THE CASE, HOWEVER IT IS HAPPENING RIGHT NOW, SO WE NEED TO COMEBACK
            // AND SEE HOW TO FIX THIS
            return "N/A"
          }
        } else {
          let ownerSubAccount = this.$lodash.find(subAccounts, {
            id: ownerId
          })
          if (ownerSubAccount) {
            return ownerSubAccount.title
          } else {
            // FIXME: THIS SHOULD NOT BE THE CASE, HOWEVER IT IS HAPPENING RIGHT NOW, SO WE NEED TO COMEBACK
            // AND SEE HOW TO FIX THIS
            return "N/A"
          }
        }
      }
    },

    /**
     * getProviderGroupName
     * @param {string} ownerId
     * @param {array} providerGroups
     * @returns {string}
     */
    getProviderGroupName(ownerId, parentAccountId, subAccounts, isPolaris) {
      if (parentAccountId === ownerId) {
        return "Any"
      } else {
        if (isPolaris) {
          let ownerProviderGroup = this.$lodash.find(subAccounts, {
            ownerId: ownerId
          })
          if (ownerProviderGroup) {
            return ownerProviderGroup.title
          } else {
            // FIXME: THIS SHOULD NOT BE THE CASE, HOWEVER IT IS HAPPENING RIGHT NOW, SO WE NEED TO COMEBACK
            // AND SEE HOW TO FIX THIS
            return "N/A"
          }
        } else {
          let ownerSubAccount = this.$lodash.find(subAccounts, {
            id: ownerId
          })
          if (ownerSubAccount) {
            return ownerSubAccount.title
          } else {
            // FIXME: THIS SHOULD NOT BE THE CASE, HOWEVER IT IS HAPPENING RIGHT NOW, SO WE NEED TO COMEBACK
            // AND SEE HOW TO FIX THIS
            return "N/A"
          }
        }
      }
    },

    /**
     * getProviderName
     * @param {string} ownerId
     * @param {string} parentAccountId
     * @param {array} providerGroups
     * @returns {string}
     */
    getProviderName(secondaryOwner) {
      if (secondaryOwner === SECONDARY_OWNER_ANY) {
        return "Any"
      } else {
        return secondaryOwner
      }
    },

    /**
    * constructDeleteFailMsg
    * @param {string} type
    * @param {string} title
    * @returns {string}
    */
    constructDeleteFailMsg(type, title) {
      return `Unable to delete ${type} "${title}" as it is in use.`
    }
  }
})



// WEBPACK FOOTER //
// ./src/XVAT/XVATRulesService.js